import { Component, OnInit,Directive, HostListener  } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt'
import { Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  isfullscreen: boolean;
  jwtHelper = new JwtHelperService();

  constructor(private router: Router) { }

  ngOnInit() {
    // const token = sessionStorage.getItem('token');
    // const decoded: any = this.jwtHelper.decodeToken(token);

    // if (token) {
    //   this.router.navigate(['/home'])
    // } else {
    //   this.router.navigate(['/login']);
    // }
    this.openfullscreen();
  }

  openfullscreen() {
    // Trigger fullscreen
    const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
      requestFullscreen(): Promise<void>;
      mozRequestFullScreen(): Promise<void>;
      webkitRequestFullscreen(): Promise<void>;
      msRequestFullscreen(): Promise<void>;
    };
  
    // if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
    //   docElmWithBrowsersFullScreenFunctions.requestFullscreen();
    // } else 
    if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) { /* Firefox */
      docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
    } else if (docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) { /* IE/Edge */
      docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
    }
    this.isfullscreen = true;
  }
}
